import ContentFootnote from './ContentFootnote'

export default ContentFootnote
